import Template from './EventSummaryDemographicsView.njk';
import Backbone from "backbone";
import Marionette from "backbone.marionette";
import { EventSummaryDemographicsBreakdownView } from "./EventSummaryDemographicsBreakdownView";

export const EventSummaryDemographicsView = Marionette.View.extend({
  template: Template,
    modelEvents: {
        "demographics.sync": "onDemographicsSync"
    },

    regions: {
        demographicsBreakdown: ".demographics-breakdown"
    },

    initialize() {
        this.demographics = new Backbone.Collection();
    },

    onDemographicsSync() {
        var demographics = new Backbone.Collection();

        this.model.get("orders").each((order) => {
            if (order.has("demographics") && order.get("status") == 200) {
                order.get("demographics").each((demographic) => {
                    var aggregate = demographics.get(demographic.id);

                    if (!aggregate) {
                        aggregate = new Backbone.Model({
                            id: demographic.id,
                            label: demographic.get("label"),
                            quantity: 0
                        });
                        demographics.add(aggregate);
                    }

                    aggregate.set("quantity", aggregate.get("quantity") + demographic.get("quantity"));
                });
            }
        });

        this.demographics.set(demographics.models);
    },

    onRender() {
        var demographicsBreakdownView = new EventSummaryDemographicsBreakdownView({
            collection: this.demographics
        });
        window.view = demographicsBreakdownView;

        this.showChildView("demographicsBreakdown", demographicsBreakdownView);
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/EventSummary/EventSummaryDemographicsView.js